document.addEventListener("DOMContentLoaded", () => {
  const BundleShared = window.BundleSharedV1;
  if (!BundleShared) {
    console.error("BundleSharedV1 helper is required before this script.");
    return;
  }

  const {
    ONE_TIME_FREE_LAMP_SELECTION,
    addItemsToCart,
    areAllBundleSlotsFilled,
    buildRechargeBundleLineItem,
    getActiveBundleGroupFromSection,
    getCurrentPurchaseType,
    getFirstIncompleteBundleSlot,
    openPopup,
  } = BundleShared;

  const oneTimeSection = document.querySelector(".one-time-bundle");
  const subscriptionSection = document.querySelector(".subscription-bundle");

  function normalizeBundleSet(targetSet = "") {
    const setMatch = String(targetSet || "").match(/\d+/);
    return setMatch ? `set-${setMatch[0]}` : String(targetSet || "");
  }

  function getSetNumber(targetSet = "") {
    return normalizeBundleSet(targetSet).match(/\d+/)?.[0] || "";
  }

  function getSetValue(el, base, setNumber) {
    if (!el || !setNumber) return "";

    const camelKey = `${base}Set${setNumber}`;

    return (
      el.dataset?.[camelKey] ||
      el.getAttribute(`data-${base}-set${setNumber}`) ||
      el.getAttribute(`data-${base}-set-${setNumber}`) ||
      ""
    );
  }

  function getSectionForPurchaseType(purchaseType = getCurrentPurchaseType()) {
    return purchaseType === "one-time" ? oneTimeSection : subscriptionSection;
  }

  function getPurchaseTypeFromSection(sectionEl) {
    if (sectionEl?.classList.contains("one-time-bundle")) return "one-time";
    if (sectionEl?.classList.contains("subscription-bundle"))
      return "subscription";
    return getCurrentPurchaseType();
  }

  function getSharedBundleSelector() {
    return (
      document.querySelector("[data-shared-bundle-selector]") ||
      document.querySelector(".bundle-selector")
    );
  }

  function getActiveBundleSetFromSection(sectionEl) {
    const sharedActive = getSharedBundleSelector()?.querySelector(
      ".bundle-option.active[data-target]",
    );
    if (sharedActive?.dataset.target) {
      return normalizeBundleSet(sharedActive.dataset.target);
    }

    const activeOption = sectionEl?.querySelector(
      ".bundle-option.active[data-target]",
    );
    const activeGroup = getActiveBundleGroupFromSection(sectionEl);

    return normalizeBundleSet(
      activeOption?.dataset.target || activeGroup?.dataset.bundleSet || "",
    );
  }

  function getActiveBundleSet() {
    return getActiveBundleSetFromSection(getSectionForPurchaseType());
  }

  function getBundleDisplayPricing(
    targetSet,
    { sectionEl = null, purchaseType = null } = {},
  ) {
    const activePurchaseType = purchaseType || getCurrentPurchaseType();
    const activeSection =
      sectionEl || getSectionForPurchaseType(activePurchaseType);
    const activeSet = normalizeBundleSet(
      targetSet || getActiveBundleSetFromSection(activeSection),
    );
    const setNumber = getSetNumber(activeSet);

    if (!setNumber) return null;

    const matchingPriceEls = Array.from(
      document.querySelectorAll("[data-bundle-price]"),
    ).filter((el) => {
      return (
        !el.dataset.purchaseType ||
        el.dataset.purchaseType === activePurchaseType
      );
    });

    const scopedPriceEls = Array.from(
      activeSection?.querySelectorAll("[data-bundle-price]") || [],
    ).filter((el) => {
      return (
        !el.dataset.purchaseType ||
        el.dataset.purchaseType === activePurchaseType
      );
    });

    const candidates = [...scopedPriceEls, ...matchingPriceEls].filter(
      (el, index, arr) => arr.indexOf(el) === index,
    );

    const priceEl = candidates.find((el) =>
      getSetValue(el, "price", setNumber),
    );
    if (!priceEl) return null;

    const price = getSetValue(priceEl, "price", setNumber);
    const compare = getSetValue(priceEl, "compare", setNumber);
    const unit = getSetValue(priceEl, "unit", setNumber);

    if (!price && !compare) return null;

    return {
      price,
      compare,
      unit,
      set: activeSet,
      purchaseType: activePurchaseType,
    };
  }

  function parseMoney(value) {
    return parseFloat(String(value || "").replace(/[^0-9.]/g, ""));
  }

  function getDiscountPercent(price, compare) {
    const cleanPrice = parseMoney(price);
    const cleanCompare = parseMoney(compare);

    if (
      !Number.isFinite(cleanPrice) ||
      !Number.isFinite(cleanCompare) ||
      cleanCompare <= cleanPrice
    ) {
      return 0;
    }

    return Math.round(((cleanCompare - cleanPrice) / cleanCompare) * 100);
  }

  function getPurchaseTargets(selector, purchaseType) {
    return Array.from(document.querySelectorAll(selector)).filter((el) => {
      return (
        !el.dataset.purchaseType || el.dataset.purchaseType === purchaseType
      );
    });
  }

  function updateBundlePriceTargets(pricing) {
    getPurchaseTargets("[data-bundle-price]", pricing.purchaseType).forEach(
      (priceSpan) => {
        priceSpan.innerHTML = pricing.compare
          ? `${pricing.price} <s>${pricing.compare}</s>`
          : pricing.price;
        priceSpan.dataset.activePurchaseType = pricing.purchaseType;
        priceSpan.dataset.activeBundleSet = pricing.set;
      },
    );
  }

  function updateBundleUnitTargets(pricing, setNumber) {
    getPurchaseTargets("[data-bundle-unit]", pricing.purchaseType).forEach(
      (unitEl) => {
        const unit = pricing.unit || getSetValue(unitEl, "unit", setNumber);
        if (!unit) return;
        unitEl.textContent = unit;
        unitEl.dataset.activePurchaseType = pricing.purchaseType;
        unitEl.dataset.activeBundleSet = pricing.set;
      },
    );
  }

  function updateDiscountTargets(pricing) {
    const percent = getDiscountPercent(pricing.price, pricing.compare);

    getPurchaseTargets("[data-saved-percentage]", pricing.purchaseType).forEach(
      (el) => {
        el.textContent = percent ? `Save ${percent}%` : "";
        el.hidden = !percent;
        el.dataset.activePurchaseType = pricing.purchaseType;
        el.dataset.activeBundleSet = pricing.set;
      },
    );

    getPurchaseTargets("[data-bundle-discount]", pricing.purchaseType).forEach(
      (el) => {
        el.textContent = percent ? `-${percent}%` : "";
        el.hidden = !percent;
        el.dataset.activePurchaseType = pricing.purchaseType;
        el.dataset.activeBundleSet = pricing.set;
      },
    );
  }

  function updatePricingHeaders(pricing, setNumber) {
    getPurchaseTargets("[data-pricing-header]", pricing.purchaseType).forEach(
      (header) => {
        const price = getSetValue(header, "price", setNumber) || pricing.price;
        const compare =
          getSetValue(header, "compare", setNumber) || pricing.compare;
        const unit = getSetValue(header, "unit", setNumber) || pricing.unit;
        const percent = getDiscountPercent(price, compare);

        const compareEl = header.querySelector(".pricing-compare");
        const currentEl = header.querySelector(".pricing-current, .ph-current");
        const discountEl = header.querySelector(
          ".pricing-discount, .ph-discount",
        );
        const unitEl = header.querySelector(".pricing-per-unit, .ph-unit");

        if (compareEl) {
          compareEl.textContent = compare || "";
          compareEl.hidden = !compare;
        }
        if (currentEl) currentEl.textContent = price || "";
        if (discountEl) {
          discountEl.textContent = percent ? `-${percent}%` : "";
          discountEl.hidden = !percent;
        }
        if (unitEl && unit) unitEl.textContent = unit;
      },
    );
  }

  function getOptionContentForPurchaseType(
    btn,
    purchaseType = getCurrentPurchaseType(),
  ) {
    return (
      (purchaseType === "one-time"
        ? btn?.dataset.oneContent
        : btn?.dataset.subContent) ||
      btn?.dataset.content ||
      ""
    );
  }

  function updatePurchaseHeadingsFromActiveOption() {
    const activeOption = getSharedBundleSelector()?.querySelector(
      ".bundle-option.active[data-target]",
    );
    const content = getOptionContentForPurchaseType(activeOption);

    if (!content) return;

    document.querySelectorAll("[data-purchase-heading]").forEach((heading) => {
      heading.textContent = content;
    });
  }

  function updateSharedSelectorLabels(purchaseType = getCurrentPurchaseType()) {
    const selector = getSharedBundleSelector();
    if (!selector) return;

    selector.querySelectorAll(".bundle-option").forEach((btn) => {
      const unit =
        purchaseType === "one-time" ? btn.dataset.oneUnit : btn.dataset.subUnit;
      const content = getOptionContentForPurchaseType(btn, purchaseType);
      const small =
        btn.querySelector("[data-bundle-option-unit]") ||
        btn.querySelector("small");

      if (unit && small) small.textContent = unit;
      if (content) btn.dataset.content = content;
    });

    updatePurchaseHeadingsFromActiveOption();
  }

  function syncBundleGroups(targetSet) {
    const activeSet = normalizeBundleSet(targetSet || getActiveBundleSet());
    if (!activeSet) return;

    document
      .querySelectorAll(".one-time-bundle, .subscription-bundle")
      .forEach((section) => {
        section
          .querySelectorAll(".bundle-group[data-bundle-set]")
          .forEach((group) => {
            const isActiveGroup =
              normalizeBundleSet(group.dataset.bundleSet) === activeSet;
            group.classList.toggle("active", isActiveGroup);
            group.classList.toggle("hidden", !isActiveGroup);
          });
      });
  }

  function updateSubscriptionPricingVisibility(
    purchaseType = getCurrentPurchaseType(),
  ) {
    document.querySelectorAll("[data-subscription-pricing]").forEach((el) => {
      el.classList.toggle("hidden", purchaseType === "one-time");
    });
  }

  function updateBundleDisplay(
    targetSet,
    { purchaseType = null, sectionEl = null } = {},
  ) {
    const activePurchaseType = purchaseType || getCurrentPurchaseType();
    const activeSection =
      sectionEl || getSectionForPurchaseType(activePurchaseType);
    const activeSet = normalizeBundleSet(
      targetSet || getActiveBundleSetFromSection(activeSection),
    );
    const setNumber = getSetNumber(activeSet);
    const pricing = getBundleDisplayPricing(activeSet, {
      sectionEl: activeSection,
      purchaseType: activePurchaseType,
    });

    if (!pricing) return null;

    updateSharedSelectorLabels(activePurchaseType);
    syncBundleGroups(activeSet);
    updateBundlePriceTargets(pricing);
    updateBundleUnitTargets(pricing, setNumber);
    updateDiscountTargets(pricing);
    updatePricingHeaders(pricing, setNumber);
    updateSubscriptionPricingVisibility(activePurchaseType);

    document.dispatchEvent(
      new CustomEvent("bundle:pricing-updated", {
        detail: pricing,
      }),
    );

    return pricing;
  }

  window.updateBundleDisplay = updateBundleDisplay;
  window.bundleBuilder_getActiveBundleSet = getActiveBundleSet;

  document.querySelectorAll(".bundle-selector").forEach((selector) => {
    selector.querySelectorAll(".bundle-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetSet = normalizeBundleSet(btn.dataset.target);

        document
          .querySelectorAll(".bundle-selector .bundle-option")
          .forEach((option) => {
            option.classList.toggle(
              "active",
              normalizeBundleSet(option.dataset.target) === targetSet,
            );
          });

        updateBundleDisplay(targetSet, {
          sectionEl: getSectionForPurchaseType(),
          purchaseType: getCurrentPurchaseType(),
        });
      });
    });
  });

  document.querySelectorAll(".purchase-type").forEach((btn) => {
    btn.addEventListener("click", () => {
      requestAnimationFrame(() => {
        const sectionEl = getSectionForPurchaseType(btn.dataset.type);
        updateBundleDisplay(getActiveBundleSetFromSection(sectionEl), {
          sectionEl,
          purchaseType: btn.dataset.type,
        });
      });
    });
  });

  const activeInitialSection = getSectionForPurchaseType();
  const activeInitialSet = getActiveBundleSetFromSection(activeInitialSection);
  updateBundleDisplay(activeInitialSet, { sectionEl: activeInitialSection });

  let selectedUpsell = null;

  function resetOneTimeUpsellButton() {
    selectedUpsell = null;

    const upsellBtn = document.getElementById("add-upsell-onetime");
    if (!upsellBtn) return;

    upsellBtn.textContent = "Add +";
    upsellBtn.disabled = false;
  }

  const upsellBtn = document.getElementById("add-upsell-onetime");
  if (upsellBtn) {
    upsellBtn.addEventListener("click", (event) => {
      const upsellEl = document.querySelector(".upsell-prod");
      const upsellId = Number(upsellEl?.dataset.variantId);

      if (!upsellId) return;

      selectedUpsell = upsellId;
      event.target.textContent = "Added ✓";
      event.target.disabled = true;
      console.log("✅ Upsell selected:", upsellId);
    });
  }

  function openBundlePickerBeforeCart(groupEl) {
    const firstIncompleteSlot = getFirstIncompleteBundleSlot(groupEl);

    if (window.bundlePopup_openSlot) {
      window.bundlePopup_openSlot(firstIncompleteSlot);
      return;
    }

    if (firstIncompleteSlot) {
      firstIncompleteSlot.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      );
      return;
    }

    openPopup("bundle-collection-popup");
  }

  async function buildBundle(
    sectionEl,
    isSubscription = true,
    includeUpsell = null,
  ) {
    const activeGroup = getActiveBundleGroupFromSection(sectionEl);

    if (!activeGroup) {
      alert("Please select a bundle first.");
      return false;
    }

    if (!areAllBundleSlotsFilled(activeGroup)) {
      openBundlePickerBeforeCart(activeGroup);
      return false;
    }

    const extraSelections = isSubscription
      ? []
      : [ONE_TIME_FREE_LAMP_SELECTION];

    const bundleResult = await buildRechargeBundleLineItem({
      groupEl: activeGroup,
      isSubscription,
      extraSelections,
      useDatasetTitle: false,
      missingBundleMessage: "Bundle setup is incomplete.",
      rechargeMissingMessage: "Recharge bundle is not ready yet.",
    });

    if (!bundleResult) return false;

    const finalItems = [bundleResult.parentItem];

    if (!isSubscription && includeUpsell) {
      finalItems.push({
        id: Number(includeUpsell),
        quantity: 1,
        properties: {},
      });

      console.log("➕ Upsell added as normal product:", includeUpsell);
    }

    try {
      const res = await addItemsToCart(finalItems);

      if (!res.ok) {
        console.error("❌ Add-to-cart error:", res);
        alert("Error adding bundle to cart.");
        return false;
      }

      console.log(
        "✅ Bundle successfully added (Recharge expansion triggered)",
      );

      if (!isSubscription) {
        resetOneTimeUpsellButton();
      }

      return true;
    } catch (err) {
      console.error("❌ Fetch error:", err);
      alert("Something went wrong. Please try again.");
      return false;
    }
  }

  window.buildRechargeBundle = async function ({
    redirectToCheckout = false,
  } = {}) {
    const purchaseType = getCurrentPurchaseType();
    const sectionEl =
      purchaseType === "one-time" ? oneTimeSection : subscriptionSection;
    const isSubscription = purchaseType !== "one-time";

    const success = await buildBundle(
      sectionEl,
      isSubscription,
      selectedUpsell,
    );

    if (success && redirectToCheckout) {
      window.location.href = "/checkout";
    }

    return success;
  };

  const addOneTimeBtn = document.getElementById("add-bundle-onetime");
  if (addOneTimeBtn) {
    addOneTimeBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      await buildBundle(oneTimeSection, false, selectedUpsell);
    });
  }

  const addSubscriptionBtn = document.getElementById("add-bundle-subscription");
  if (addSubscriptionBtn) {
    addSubscriptionBtn.addEventListener("click", async (event) => {
      event.preventDefault();
      await buildBundle(subscriptionSection, true);
    });
  }
});
